/**
 * Floating rail — scroll dimming.
 *
 * The rail is fixed at the viewport's vertical centre, so once the visitor scrolls past
 * the hero it sits directly on top of whatever copy the page has scrolled under it, and
 * an 80%-white wash over a 6px backdrop blur makes those words unreadable. Past that
 * point the rail steps back — the element fades and its blur is withdrawn so the page
 * shows through — and steps forward again the moment it is hovered or focused, which the
 * CSS handles (`.newsletter-bar--dimmed`, this section's stylesheet).
 *
 * The threshold is a fraction of the viewport rather than an IntersectionObserver on the
 * hero, because the rail must not know what section happens to be first: the condition
 * is "the visitor has left the top of the page", not "a particular neighbour moved".
 *
 * A custom element, not an init-on-load script, because the theme editor re-renders the
 * section on every setting change and the freshly parsed <newsletter-bar> must upgrade
 * and rebind itself, where a bound-once script would leave the new copy undimmed forever.
 */
(function () {
  'use strict';

  if (customElements.get('newsletter-bar')) return;

  const DIMMED = 'newsletter-bar--dimmed';

  class NewsletterBar extends HTMLElement {
    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      // 40% of a viewport: far enough that the hero the rail was designed to sit on has
      // visibly moved off, close enough that the first band of section copy scrolling
      // under the rail already finds it dimmed.
      this.classList.toggle(DIMMED, window.scrollY > window.innerHeight * 0.4);
    }
  }

  customElements.define('newsletter-bar', NewsletterBar);
})();
